import { useQuery } from '@tanstack/react-query';
import { useApiEssentials } from '../../../shared/hooks/useApiEssentials';
import {
  DOCUMENTATION_API_BASE_PATH,
  documentationQueryDefaults,
  documentationQueryKeys,
  fetchDocumentationItem,
} from '../api/documentationApi';
import { DocumentationItem } from '../api/types';

export function useDocumentationItem(documentTagName: string | undefined) {
  const { apiUrl, getIdToken, isSignedIn } = useApiEssentials(
    DOCUMENTATION_API_BASE_PATH,
  );

  return useQuery<DocumentationItem, Error>({
    queryKey: documentationQueryKeys.item(documentTagName ?? ''),
    queryFn: async () => {
      const idToken = await getIdToken();
      return fetchDocumentationItem(
        apiUrl,
        idToken,
        documentTagName ?? '',
      );
    },
    enabled: !!documentTagName && !!apiUrl && isSignedIn,
    ...documentationQueryDefaults,
  });
}
